import { UtilitiesJson } from 'src/app/services/utilities.json';
import { Component, OnInit, ViewChild } from '@angular/core';
import { JsonEditorComponent, JsonEditorOptions } from "ang-jsoneditor";
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { BaseComponent } from 'src/app/shared/base.component';
import { TenantUIService } from '../../../tenant-ui.service';
import { filter } from 'rxjs/operators';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';

AutoUnsubscribe()
@Component({
    selector: 'app-settings-editor',
    templateUrl: './settings-editor.component.html',
    styleUrls: ['./settings-editor.component.scss']
})
export class SettingsEditorComponent extends BaseComponent implements OnInit {
    editorOptions: JsonEditorOptions;
    @ViewChild(JsonEditorComponent, { static: false }) editor!: JsonEditorComponent;
    jsonControl: UntypedFormControl;
    savedJsonData: any;

    constructor(
        protected service: TenantUIService,
        private fb: UntypedFormBuilder
    ) {
        super();
        this.editorOptions = new JsonEditorOptions();
        this.editorOptions.modes = ['code', 'text', 'tree', 'view'];
        this.editorOptions.mainMenuBar = true;
        this.editorOptions.statusBar = true;
        this.editorOptions.navigationBar = true;
        this.editorOptions.mode = 'tree'; // default mode
        this.editorOptions.history = true; // enable history
    }

    async ngOnInit() {
        this.subscriptions.push(this.service.currentTenantConfiguration$.pipe(filter(_ => !!_)).subscribe(configData => {
            this.savedJsonData = configData;

            this.jsonControl = null;
            setTimeout(() => {
                this.jsonControl = this.fb.control(null, [Validators.required]);
                this.jsonControl.setValue(configData);
            });

        }));
    }

    async save($event: Event) {
        const json = UtilitiesJson.toJsonObject(this.editor.getText());

        await this.service.saveChangesConfirmation((async () => { await this.service.saveTenantConfiguration(json); this.savedJsonData = json;}),
            {
                message: `Please confirm the changes? After accept, the changes will be applied  permanently in ${this.service.selectedTenant.displayName} configuration.`,
            }
        );
    }

    reset($event: Event) {
        this.jsonControl.setValue(this.savedJsonData);
    }

}
